import React from 'react';
import { Navbar, Container, Nav, Button, Image  } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

const NavBar = () => {
  const { currentUser } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log('User signed out');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Navbar className='nav' expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
        <span className='logo-name'>Deepstone Capital</span>
        <Image src={process.env.PUBLIC_URL + '/logo2.png'} alt="Deepstone Logo" width={30} height={30} className="d-inline-block align-top" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/about" className="custom-nav-link">About</Nav.Link>
            <Nav.Link as={Link} to="/contact" className="custom-nav-link">Contact</Nav.Link>
            <Nav.Link as={Link} to="/blog" className="custom-nav-link">Blog</Nav.Link>
            <Nav.Link as={Link} to="/dashboard" className="custom-nav-link">Dashboard</Nav.Link>
          </Nav>
          <Nav className="ml-auto">
            <Button id="book-a-meeting" as={Link} to="/book-a-meeting" variant="primary" >Book a Meeting</Button>
            {currentUser ? (
              <Button as={Link} to="/" variant="outline-light" onClick={handleSignOut}>Sign Out</Button>
            ) : (
              <Button as={Link} to="/signin" variant="outline-light">Sign In</Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
